import { useState } from "react";
import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-12 w-full border-b border-background-200 bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">FAQ</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">常见问题</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              读者问得最多的几个问题，我们把它放在这里。如果还有别的问题，欢迎通过页面下方的表单告诉我们。
            </p>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
            >
              <i className="ri-information-line text-base" aria-hidden="true" />
              了解我们的内容原则
            </Link>
          </div>

          <div className="lg:col-span-8">
            <dl className="divide-y divide-background-300 border-y border-background-300">
              {faqs.map((item, index) => {
                const isOpen = open === index;
                return (
                  <div key={item.q} className="py-1">
                    <dt>
                      <button
                        type="button"
                        onClick={() => setOpen(isOpen ? null : index)}
                        aria-expanded={isOpen}
                        className="flex w-full items-start justify-between gap-4 py-4 text-left"
                      >
                        <span className="flex gap-3">
                          <span className="font-heading text-sm font-semibold text-primary-700">
                            Q{String(index + 1).padStart(2, "0")}
                          </span>
                          <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                            {item.q}
                          </span>
                        </span>
                        <i
                          className={`mt-0.5 shrink-0 text-lg text-foreground-500 transition-transform ${
                            isOpen ? "ri-subtract-line" : "ri-add-line"
                          }`}
                          aria-hidden="true"
                        />
                      </button>
                    </dt>
                    <dd className={isOpen ? "animate-fade-in block pb-5 md:pl-9" : "hidden"}>
                      <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                    </dd>
                  </div>
                );
              })}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}